// test2395
(2395 && 0);
